import { Alert } from "@mui/material";
import { useReadOnlyMode } from "./useReadOnlyMode";

const READ_ONLY_BANNER_MESSAGE = "Aplikacja w trybie tylko do odczytu. Zapisy są zablokowane.";

export function ReadOnlyBanner() {
  const { isReadOnly } = useReadOnlyMode();
  if (!isReadOnly) {
    return null;
  }
  return (
    <Alert severity="warning" sx={{ borderRadius: 0 }}>
      {READ_ONLY_BANNER_MESSAGE}
    </Alert>
  );
}
